// src/pages/FacebookGroups.jsx
import React, { useState, useMemo, useEffect } from "react";
import "./FacebookGroups.css";
import data from "../../assets/data/Comunidad.json";

import StateSelector from "../../components/StateSelector/StateSelector";
import GroupList from "../../components/GroupList/GroupList";

export default function FacebookGroups() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const allStates = useMemo(() => {
    const uniqueStates = new Set(data.map((item) => item.Estado));
    return Array.from(uniqueStates).sort((a, b) => a.localeCompare(b));
  }, []);

  const [selectedState, setSelectedState] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const perPage = 6;

  const filteredGroups = useMemo(() => {
    if (!selectedState) return [];
    return data.filter((item) => item.Estado === selectedState);
  }, [selectedState]);

  const totalPages = Math.ceil(filteredGroups.length / perPage);
  const startIdx = (currentPage - 1) * perPage;
  const pageItems = filteredGroups.slice(startIdx, startIdx + perPage);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  return (
    <main className="fg-page">
      <section className="fg-hero">
        <div className="fg-hero__inner">
          <h1>
            Explora <span>comunidades</span>
          </h1>

          <p>
            ¿Estás por entrar a la uni o ya sobreviviendo los exámenes? Aquí
            encontrarás grupos donde se comparte lo bueno: becas, libros,
            cuartos, chambitas y más.
          </p>

          <p>
            Elige tu estado, encuentra tu universidad y únete a comunidades que
            pueden hacerte la vida más fácil.
          </p>
        </div>
      </section>

      <section className="fg-content">
        <div className="fg-card">
          <div className="fg-selector-block">
            <h2>Busca por estado</h2>

            <p>
              Primero selecciona tu estado para ver las comunidades disponibles.
            </p>

            <StateSelector
              className="fg-dropdown"
              states={allStates}
              selectedState={selectedState}
              onSelect={(state) => {
                setSelectedState(state);
                setCurrentPage(1);
              }}
            />
          </div>

          {!selectedState && (
            <div className="fg-empty-state">
              <h3>Selecciona un estado para comenzar.</h3>

              <p>
                Cuando elijas una ubicación, te mostraremos grupos activos y
                recursos útiles para estudiantes.
              </p>

              <div
                className="fg-empty-preview"
                aria-label="Tipos de comunidades"
              >
                <span>🏠 Cuartos</span>
                <span>🎓 Becas</span>
                <span>📚 Libros</span>
                <span>💼 Trabajos</span>
                <span>✨ Otros</span>
              </div>
            </div>
          )}

          {selectedState && filteredGroups.length > 0 && (
            <>
              <div className="fg-results-heading">
                <span>{selectedState}</span>
                <h3>Comunidades disponibles</h3>
              </div>

              <GroupList groups={pageItems} />

              {totalPages > 1 && (
                <div className="fg-pagination">
                  <button
                    type="button"
                    className="fg-page-button"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage((page) => page - 1)}
                    aria-label="Página anterior"
                  >
                    ←
                  </button>

                  {Array.from(
                    { length: totalPages },
                    (_, index) => index + 1,
                  ).map((pageNumber) => (
                    <button
                      key={pageNumber}
                      type="button"
                      className={`fg-page-button fg-page-number ${
                        pageNumber === currentPage ? "is-active" : ""
                      }`}
                      onClick={() => setCurrentPage(pageNumber)}
                    >
                      {pageNumber}
                    </button>
                  ))}

                  <button
                    type="button"
                    className="fg-page-button"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage((page) => page + 1)}
                    aria-label="Página siguiente"
                  >
                    →
                  </button>
                </div>
              )}
            </>
          )}

          {selectedState && filteredGroups.length === 0 && (
            <div className="fg-no-results">
              <h3>No encontramos grupos para {selectedState}.</h3>
              <p>
                Estamos actualizando la base de comunidades. Prueba con otro
                estado o vuelve más tarde.
              </p>
            </div>
          )}
        </div>
      </section>
    </main>
  );
}
